module.exports = __webpack_public_path__ + "static/media/crm.0aa27297.svg";